export const routes = {
	welcome: '/welcome',
	handoff: '/handoff',
	document: '/document',
	acceptedDocuments: '/accepted-documents',
	error: {
		path: '/error',
		unhandled: '/error/unhandled',
		invalidSession: '/error/invalid-session',
		cameraAccessDeclined: '/error/camera-access-declined',
		cameraAccessDenied: '/error/camera-access-denied',
		cameraError: '/error/camera-error',
		poorCameraQuality: '/error/poor-quality',
	},
	access: '/access',
	selfie: '/face',
	complete: '/complete',
	photoError: '/photo-error',
	notReady: '/not-ready'
};
